import Caret from 'components/utils/icons/Caret';
import LogoInitial from 'components/utils/icons/LogoInitial';
import React from 'react';

import {
	Bbb,
	Container,
	Content,
	Desktop,
	Hipaa,
	LegitScript,
	Logos,
	Mobile,
} from './styles';

const Links = ({ className }) => (
	<div className={className}>
		<a href="https://www.apostrophe.com/slather/" target="_blank" rel="noreferrer">Slather</a>
		<a href="https://faq.apostrophe.com" target="_blank" rel="noreferrer">FAQs</a>
		<a href="https://www.apostrophe.com/apostrophe-privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
	</div>
);

const Social = ({ className }) => (
	<div className={className}>
		<a href="http://www.facebook.com/hi.apostrophe" target="_blank" rel="noreferrer">Facebook</a>
		<a href="http://www.instagram.com/hi_apostrophe" target="_blank" rel="noreferrer">Instagram</a>
		<a href="http://www.twitter.com/hi_apostrophe" target="_blank" rel="noreferrer">Twitter</a>
	</div>
);

const Legal = () => (
	<div>
		<a className="dark" href="https://www.apostrophe.com/terms-of-service/" target="_blank" rel="noreferrer">Terms</a>
		<a className="dark" href="https://www.apostrophe.com/medical-notice-of-privacy-practices/" target="_blank" rel="noreferrer">Medical Notice of Privacy Practices</a>
		<a className="dark" href="https://www.apostrophe.com/telehealth-consent/" target="_blank" rel="noreferrer">Telehealth Consent</a>
		<a className="dark" href="https://www.apostrophe.com/open-payments-notice/" target="_blank" rel="noreferrer">Open payments notice</a>
	</div>
);

const Footer = () => {
	function scrollToTop () {
		window.scrollTo(0,
			0)
	}

	return (
		<Container>
			<Content>
				<Desktop>
					<div className="logo-initial">
						<LogoInitial fill="#ffffff" width={40} height={48} />
					</div>
					<div className="center">
						<div className="center-top">
							<div>
								<a href="mailto:care@apostrophe.com?subject=Apostrophe%20Support%20Message">
                  care@apostrophe.com
								</a>
							</div>
							<Links className="footer-links" />
						</div>
						<Social className="center-bottom" />
					</div>
					<div className="right">
						<Caret className="caret" onClick={scrollToTop} />
						<Legal />
					</div>
				</Desktop>
				<Mobile>
					<div className="icons">
						<LogoInitial fill="#ffffff" width={40} height={48} />
						<Caret className="caret" onClick={scrollToTop} />
					</div>
					<div className="customer-service">
						<a href="mailto:care@apostrophe.com?subject=Apostrophe%20Support%20Message">care@apostrophe.com</a>
					</div>
					<div className="section divided">
						<Links />
						<Social />
					</div>
					<div className="section dark">
						<Legal />
						<div className="mobile-copyright">© 2022 Apostrophe</div>
					</div>
				</Mobile>
				<Logos>
					<div className="accreditation">
						<LegitScript>
							<a href="http://legitscript.com/pharmacy/apostrophe.com" target="_blank" rel="nofollow noopener noreferrer">
								<img src="https://static.legitscript.com/seals/3879723.png" alt="LegitScript Approved"/>
							</a>
						</LegitScript>
						<Bbb>
							<a href="https://www.bbb.org/greater-san-francisco/business-reviews/dermatologist/yoderm-in-oakland-ca-880490/#sealclick" target="_blank" rel="nofollow noopener noreferrer">
								<img src="https://seal-goldengate.bbb.org/seals/blue-seal-293-61-whitetxt-bbb-880490.png" alt="Apostrophe BBB Business Review" />
							</a>
						</Bbb>
						{/* <Hipaa>
              <img src="https://assets.apostrophe.com/img/Footer/hipaa-accountable-badge.png" alt="Apostrophe HIPAA"/>
            </Hipaa> */}
					</div>
					<div className="copyright">© 2022 Apostrophe</div>
				</Logos>
			</Content>
		</Container>
	);
};

export default Footer;
